// Central place for backend wiring. The API contract is defined in
// BrandonUserStoryAPI.md / README.md (§4.1) — every endpoint is prefixed
// `/api/v1`. Override REACT_APP_API_BASE_URL per environment (see .env.example).
//
// This can be a relative path (e.g. "/api/v1") instead of an absolute
// URL — every use below is a plain template-literal prefix passed to
// fetch()/window.location.href, both of which resolve a relative value
// against the page's own origin. Set it to a relative path whenever this
// app is deployed on the same origin as the backend (see the backend's
// CORS_ALLOWED_ORIGINS/COOKIE_SAMESITE .env.example notes) to make every
// request genuinely same-origin — no CORS, and the CSRF-token-in-body
// dance in ./csrf.js becomes unnecessary (though it still works fine).
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

// GET /auth/login — starts the Microsoft Entra ID sign-in redirect (README §4.1).
// No password is ever collected by this app: this link hands off to the
// backend, which redirects to login.microsoftonline.com, and Entra redirects
// back once the person has authenticated.
export const ENTRA_LOGIN_URL = `${API_BASE_URL}/auth/login`;

// GET /auth/logout — ends both the local session and Entra's own SSO
// session (RP-initiated logout, BACKEND_API_FLOW.md §3.3). Like login,
// this must be a real navigation (`window.location.href`), not a `fetch`
// — the response is a 302 chain out to Entra and back that only a
// browser can follow.
export const ENTRA_LOGOUT_URL = `${API_BASE_URL}/auth/logout`;

// GET /auth/me — who (if anyone) the session cookie belongs to
// (BACKEND_API_FLOW.md §3.5). Called with `credentials: 'include'` since
// the SPA and backend are on different origins in dev.
export const AUTH_ME_URL = `${API_BASE_URL}/auth/me`;

// GET /auth/csrf — returns { csrftoken } in the JSON body. The SPA and API
// are on different registrable domains in every deployed environment (no
// shared parent domain), so document.cookie can never see the csrftoken
// cookie the API sets — it belongs to the API's own domain, not the SPA's.
// This endpoint hands the token back in the response body instead, for
// src/config/csrf.js to hold in memory and attach as X-CSRFToken.
export const CSRF_URL = `${API_BASE_URL}/auth/csrf`;
